<template>
    <base-modal :visible="true" :title="text" @close="$emit('close')" min-height="1rem">
        <base-button @click="$emit('ok')" :loading="loading" class="is-danger btn" text="Ok"/>
        <base-button @click="$emit('close')" class="btn" text="Close"/>
    </base-modal>
</template>

<script>
export default {
    name: 'ConfirmModal',
    props: ['text', 'loading'],
};
</script>

<style scoped>
    .btn {
        float: right;
        margin: 0 0 0 1rem !important;
        min-width: 5rem;
    }
</style>
